import { EEntities } from '@/types'
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
      validator: (value: string) => {
        const allowedEntities: string[] = Object.keys(EEntities).map(
          (k: string) => EEntities[k as keyof typeof EEntities],
        )
        return allowedEntities.indexOf(value) !== -1
      },
    },
  },
})
